module.exports = __webpack_public_path__ + "static/media/screenshot(28).dddf0c85.jpg";